import { useEffect, useRef, useState } from 'react';

const VimeoAudioPlayer = ({ multimediaData }) => {

    const audioRef = useRef(null);

    const [duration, setDuration] = useState(0);
    const [selectedMarker, setSelectedMarker] = useState(null);

    // Start with your default markers
    const [markers, setMarkers] = useState([
        // { time: 5, text: "Intro scene" },
        // { time: 15, text: "Action starts" },
        // { time: 27, text: "Climax" }
    ]);

    // Initialize Vimeo Player
    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        // Set duration once metadata is loaded
        const handleLoadedMetadata = () => {
            setDuration(audio.duration);
        };

        audio.addEventListener("loadedmetadata", handleLoadedMetadata);

        return () => {
            audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
        };
    }, []);

    console.log("duration : ",duration)

    // Function to add marker at current playback position
    const addMarker = (description) => {
        const audio = audioRef.current;
        if (!audio) return;

        const currentTime = audio.currentTime;

        setMarkers((prev) => [
            ...prev,
            { time: Math.floor(currentTime), text: description },
        ]);
    };

    // Jump to a marker
    const handleMarkerClick = (marker) => {
        const audio = audioRef.current;
        if (!audio) return;

        audio.currentTime = marker.time;
        audio.pause();
        setSelectedMarker(marker);
    };

    return (
        <div style={{ position: "relative", width: "640px", margin: "auto" }}>

            {/* Native audio player */}
            <audio
                ref={audioRef}
                src={multimediaData?.url}
                controls
                style={{ width: "100%" }}
            />

            {/* Marker track */}
            <div
                style={{
                    width: "100%",
                    position: "relative",
                    height: "8px",
                    background: "#ccc",
                    marginTop: "4px"
                }}
            >
                {markers.map((marker, index) => (
                    <div
                        key={index}
                        title={`${marker.text} (${marker.time}s)`}
                        style={{
                            position: "absolute",
                            bottom: 0,
                            left: `${(marker.time / duration) * 100}%`,
                            transform: "translateX(-50%)",
                            width: "4px",
                            height: "8px",
                            background: "red",
                            cursor: "pointer"
                        }}
                        onClick={() => handleMarkerClick(marker)}
                    />
                ))}
            </div>

            {/* Marker description popup */}
            {selectedMarker && (
                <div
                    style={{
                        marginTop: "10px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        background: "#f9f9f9"
                    }}
                >
                    <strong>Marker:</strong> {selectedMarker.text} (
                    {selectedMarker.time}s)
                </div>
            )}

            {/* Button */}
            <div className="marker-button-wrapper" style={{marginTop: "10px",}}>
                {/* <button
                    className="add-marker-btn"
                    onClick={() =>
                        addMarker(prompt("Enter marker description:") || "No description")
                    }
                >
                    Add Marker
                </button> */}
            </div>
        </div>
    );
}

export default VimeoAudioPlayer
